export default {
	init() {
		// JavaScript to be fired on single posts

		/** MASTHEAD PRGRESSIVE IMAGES **/
		var overlay = document.querySelector('.single-post__overlay');

		if (overlay) {
			// Load full size image. When loaded, add it as a background image to the div
			if (overlay.dataset.imageSrc) {
				var img = new Image();
				img.src = overlay.dataset.imageSrc;
				img.onload = function () {
					overlay.style.backgroundImage = 'url(' + img.src + ')';
					overlay.classList.add('fade-in');
				};
			}
		}
		/** END MASTHEAD PRGRESSIVE IMAGES **/
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/single.js